import { useState } from "react";
import GoogleSearchInput from "components/Search_Google/GoogleSearchInput";
import { APIProvider } from '@vis.gl/react-google-maps';
import styles from './toolbar.module.css'

type PageProps = {
    currentLocation: string;
    isPortfolioPage: boolean;
    type: string;
    forSale?: boolean;
};

const LocationSearchDisplay = ({ currentLocation, isPortfolioPage, type, forSale }: PageProps) => {
    const [locationLoookUp, setLocationLoookUp] = useState(isPortfolioPage);
    const [preventBlur, setPreventBlur] = useState<boolean>(false);
    const [isLoaded, setIsloaded] = useState<boolean>(false);
    const onLoadMeth = () => {
        setIsloaded(true)
        setTimeout(() => {
            const input = document.getElementById('google-search-input');
            if (input) {
                input.focus()
            }
          }, 500)
    }
    return (

        <div className={styles.locationSearch} onBlur={(e) => {
            if (!isPortfolioPage && !preventBlur) {
                setLocationLoookUp(false)
            }

        }}> {locationLoookUp &&
                <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_APIS_KEY_CSR ?? ''} onLoad={() => onLoadMeth()}>

                    {isLoaded && (
                        <GoogleSearchInput type={type} searchPage={true} setPreventBlur={setPreventBlur} forSale={forSale} />
                    )}

                    {isLoaded && (
                        <div></div>
                    )}
                </APIProvider>
            }
            {
                !locationLoookUp && (
                    <div className={styles.defaultLocation}onClick={(e) => {
                        setLocationLoookUp(true)
                    }} >
                        {currentLocation} <img className="light" src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/cross-in-circle.svg`} width="20" height="20" alt="Not Included" />
                    </div>

                )
            }

        </div >
    )
}

export default LocationSearchDisplay;